import type { PresenceUser } from '@mentimeter/editor-realtime';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Light } from '@mentimeter/ragnar-ui/themes';
import { Text } from '@mentimeter/ragnar-ui/text';
import { getAvatarColor } from '@mentimeter/ragnar-ui/avatar';
import { CollaboratorInfo } from './CollaboratorInfo';
import { Avatar } from './Avatar';

interface PresenceAvatarsT {
  collaborators: PresenceUser[];
  maxAvatarsInList?: number;
  onAvatarClick?: ((avatar?: string) => void) | undefined;
  activePresenters: PresenceUser[];
  onGetNameInitials: (name?: string, singleLetter?: boolean) => string;
}

export const AvatarList = ({
  collaborators,
  activePresenters,
  maxAvatarsInList,
  onAvatarClick: onClick,
  onGetNameInitials,
}: PresenceAvatarsT) => {
  return (
    <>
      {collaborators.map((c, i) => {
        if (i < Number(maxAvatarsInList)) {
          return (
            <Box
              mt={i > 0 ? 2 : 0}
              key={c.device_id}
              flexDirection="row"
              maxWidth="12.5rem"
              alignItems="center"
            >
              <Light>
                <Avatar
                  size={3}
                  initials={onGetNameInitials(c.name)}
                  name={c.name}
                  isPresenting={activePresenters.includes(c)}
                  onAvatarClick={() => onClick && onClick(c.location)}
                  profilePictureUrl={c.profile_picture_url}
                  className={getAvatarColor(c.user_id?.toString())}
                />
              </Light>
              <Box mx={2} alignItems="flex-start" flex="1 1 auto">
                <CollaboratorInfo collaborator={c} />
              </Box>
            </Box>
          );
        } else if (i === maxAvatarsInList) {
          return (
            <Text mt="space3" variant="editorBodySm" key={c.device_id}>
              And {collaborators.length - maxAvatarsInList} more
            </Text>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};
